import { render, staticRenderFns } from "./CourseNav.vue?vue&type=template&id=16634562&scoped=true"
import script from "./CourseNav.vue?vue&type=script&lang=js"
export * from "./CourseNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16634562",
  null
  
)

export default component.exports